import { css } from '@emotion/css';
import {
  Dimensions4,
  ColorsSuccess900,
  ColorsError900,
} from '@efexteam/design-tokens';

const container = css({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gap: Dimensions4,
  paddingTop: Dimensions4,
});

const validationItem = (isValid: boolean) =>
  css({
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    fontSize: '0.875rem',
    color: isValid ? ColorsSuccess900 : ColorsError900,
  });

const validIcon = css({
  color: ColorsSuccess900,
});

const invalidIcon = css({
  color: ColorsError900,
});

const PasswordValidationListStyles = {
  container,
  validationItem,
  validIcon,
  invalidIcon,
};

export default PasswordValidationListStyles;
